import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionSirets, ElectionVenue } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-sirets-verification',
  templateUrl: 'cerfa-sirets-verification.component.html',
  styleUrls: ['./cerfa-sirets-verification.component.less', '../../../shared/common.less'],
})

export class CerfaSiretsVerificationComponent implements OnInit {
  @Input() sirets: ElectionSirets;
  @Input() isValidated: boolean = false;
  @Output() siretsChange = new EventEmitter<ElectionSirets>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();
  isExpanded: boolean = true;
  needPap: boolean = undefined;

  constructor() {}
  
  onSiretsChange() {
    this.siretsChange.emit(this.sirets);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  trackByIndex(index: number): number {
    return index;
  }

  onEdit() {
    this.editRequested.emit();
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  
  ngOnInit(): void {
  }
}
